import { Button, Paper } from "@mantine/core";
import { notifications } from "@mantine/notifications";

import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import SeasonForm from "../../components/form/SeasonForm";
import { useAddSeason, useUpdateSeason } from "../../utils/mutations";
import { useSeasonById } from "../../utils/queries";
import useStore from "../../utils/store";

const AddSeason = () => {
  const user = useStore((state) => state.user);
  const navigate = useNavigate();
  const params = useParams();
  const id = params.id;
  const seriesId = params.seriesId;
  

  useEffect(() => {
    if (id && !user?.updateSeries) {
      notifications.show({ message: "You don't have permission to edit season", color: "red" });
      navigate(`/seasons/${seriesId}`);
    } else if (!id && !user?.addSeries) {
      notifications.show({ message: "You don't have permission to add season", color: "red" });
      navigate(`/seasons/${seriesId}`);
    }
  }, [id, user]);

  const { isPending, mutate } = useAddSeason();
  const { isPending: isUpdating, mutate: update } = useUpdateSeason();
  const { data, isLoading } = useSeasonById(id);
  

  if (!user?.addSeries && !user?.updateSeries) {
    return null;
  }

  return (
    <>
      
      <Paper withBorder p="md"
        loading={isLoading}
        title={id ? "Edit Season" : "Add Season"}
        style={{
          maxWidth: "600px",
          width: "100%",
          marginInline: "auto",
        }}
      >
        <SeasonForm
          onFinish={(values) => {
            if (id) {
              update({ id: id, data: values });
            } else {
              values.series = seriesId;
              mutate(values);
            }
          }}
          update={data}
          submit={
            <Button
              type="submit"
              loading={isPending || isUpdating}
            >
              Submit
            </Button>
          }
        />
      </Paper>
    </>
  );
};

export default AddSeason;
